export default __webpack_public_path__ + "static/media/optimism-logo.34412af2.svg";